import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <div className="h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-9xl font-serif font-bold text-primary/20">404</h1>
      <h2 className="text-3xl font-bold text-primary mt-4">Ops! Fant ikke siden.</h2>
      <p className="text-muted-foreground mt-4 max-w-md">
        Siden du leter etter finnes ikke, eller har blitt flyttet. Kanskje du vil se på noen planter i stedet?
      </p>
      <Link to="/" className="mt-8">
        <Button size="lg" className="rounded-full px-8">Gå til forsiden</Button>
      </Link>
    </div>
  );
};

export default NotFound;
